import React, { useContext, useState } from 'react'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import styled, { ThemeContext } from 'styled-components'
import { lighten } from 'polished';
import flowRight from 'lodash/flowRight'
import Button from 'shared/components/Button'
import Box from 'shared/components/Box'
import SvgArrowBackIcon from 'assets/icons/ArrowBack'
import useQuery from 'shared/hooks/useQuery'
import { NoteTypeWithStatus, Attachment } from 'shared/components/Notes/models/note'
import DefaultImage from 'assets/images/logo-small.png'
import ProtectedImage from 'shared/components/ProtectedImage'

type Props = WrappedProps<NoteTypeWithStatus> & {
}

function PreviewAttachment(props: Props) {
  const {
    formState,
    formHandlers,
    onClose,
    onContinue,
  } = props
  const { fields } = formState
  const theme = useContext(ThemeContext)

  return (
    <PreviewAttachmentBodyContainer className="confirm-dialog-container">
      <BackButton onClick={onContinue}>
        <SvgArrowBackIcon fill={theme?.colors?.main}/>
        Back to Program/Event Note
      </BackButton>
      <DialogTitle>Attached Image</DialogTitle>
      <ImageContainer>
        {(fields?.attachments ?? [])?.map((attachment: Attachment) => (
          <ProtectedImage src={attachment?.attachment_url || ''} defaultSrc={DefaultImage} />
        ))}
      </ImageContainer>
      <StyledButton
        variant="primary"
        onClick={onClose}
        width="110px"
      >
        Close
      </StyledButton>
    </PreviewAttachmentBodyContainer>
  )
}

const WrappedPreviewAttachment = flowRight(withDialog())(PreviewAttachment)

const DialogTitle = styled(Box)`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.secondary};
  margin-top: 1.5rem;
`

const ImageContainer = styled(Box)`
  width: 400px;
  height: 400px;
  border-radius: 4px;
  margin: 1rem auto 0;
  background: ${({ theme }) => lighten(0.61, theme?.colors?.main)};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;

  img {
    // width: 100%;
    // height: 100%;
    // object-fit: contain;
    max-width: 100%;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme?.colors?.label};
    }

    &::-webkit-scrollbar {
      background-color: #F5F5F5;
    }
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    background-color: transparent;
  }
`

const BackButton = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;

  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.main};

  svg {
    margin-right: 8px;
  }
`

const StyledButton = styled(Button)`
  margin: 40px auto 0;
`


const PreviewAttachmentBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`

WrappedPreviewAttachment.defaultProps = {
  // continueIsDisabled(data: NoteType) {
  //   return !data?.message?.length
  // },
}

export default WrappedPreviewAttachment
